import React, { useEffect, useState } from 'react';
const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;
const STORAGE_KEY = 'countdown_target';
function getTarget(): number {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const target = parseInt(stored, 10);
    if (target > Date.now()) return target;
  }
  const target = Date.now() + FIFTEEN_MINUTES_MS;
  localStorage.setItem(STORAGE_KEY, target.toString());
  return target;
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const target = getTarget();
    const calculateTimeLeft = () => {
      const difference = target - Date.now();
      if (difference > 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center mx-1 md:mx-2" data-id="element-63">
      <div className="w-16 h-16 md:w-20 md:h-20 bg-dark-surface border border-violet-glow/50 rounded-lg flex items-center justify-center shadow-[0_0_15px_rgba(139,92,246,0.3)] backdrop-blur-sm" data-id="element-64">
        <span className="text-2xl md:text-4xl font-bold text-white font-display" data-id="element-65">
          {value.toString().padStart(2, '0')}
        </span>
      </div>
      <span className="text-[10px] md:text-xs text-violet-light mt-1 font-medium tracking-wider" data-id="element-66">
        {label}
      </span>
    </div>;
  return <div className="flex justify-center items-center py-6 animate-pulse-glow" data-id="element-67">
      <TimeUnit value={timeLeft.minutes} label="MINUTOS" data-id="element-68" />
      <span className="text-2xl md:text-4xl text-violet-glow font-bold -mt-6" data-id="element-69">
        :
      </span>
      <TimeUnit value={timeLeft.seconds} label="SEGUNDOS" data-id="element-70" />
    </div>;
}